<template>
  <div>
    <h1>Edit {{ item && item['@id'] }}</h1>

    <div
      v-if="created"
      class="alert alert-success"
      role="status">{{ created['@id'] }} created.</div>
    <div
      v-if="updated"
      class="alert alert-success"
      role="status">{{ updated['@id'] }} updated.</div>
    <div
      v-if="isLoading || deleteLoading"
      class="alert alert-info"
      role="status">Loading...</div>
    <div
      v-if="error"
      class="alert alert-danger"
      role="alert">
      <span
        class="fa fa-exclamation-triangle"
        aria-hidden="true" /> {{ error }}
    </div>
    <div
      v-if="deleteError"
      class="alert alert-danger"
      role="alert">
      <span
        class="fa fa-exclamation-triangle"
        aria-hidden="true" /> {{ deleteError }}
    </div>

    <EXSBInvoiceTypeForm
      v-if="item"
      :handle-submit="onSendForm"
      :handle-update-field="updateField"
      :values="item"
      :errors="violations"
      :initial-values="retrieved" />

    <router-link
      v-if="item"
      :to="{ name: 'EXSBInvoiceTypeList' }"
      class="btn btn-default">Back to list</router-link>
    <button
      class="btn btn-danger"
      @click="del">Delete</button>
  </div>
</template>

<script>
import { mapActions, mapGetters } from 'vuex'
import EXSBInvoiceTypeForm from './Form.vue'

export default {
  components: {
    EXSBInvoiceTypeForm
  },

  data () {
    return {
      item: {}
    }
  },

  computed: {
    ...mapGetters({
      isLoading: 'exsbinvoicetype/update/isLoading',
      error: 'exsbinvoicetype/update/error',
      deleteError: 'exsbinvoicetype/del/error',
      deleteLoading: 'exsbinvoicetype/del/isLoading',
      created: 'exsbinvoicetype/create/created',
      deleted: 'exsbinvoicetype/del/deleted',
      retrieved: 'exsbinvoicetype/update/retrieved',
      updated: 'exsbinvoicetype/update/updated',
      violations: 'exsbinvoicetype/update/violations'
    })
  },

  watch: {
    // eslint-disable-next-line object-shorthand,func-names
    deleted: function (deleted) {
      if (!deleted) {
        return
      }

      this.$router.push({ name: 'EXSBInvoiceTypeList' })
    }
  },

  beforeDestroy () {
    this.reset()
  },

  created () {
    this.retrieve(decodeURIComponent(this.$route.params.id))
  },

  methods: {
    ...mapActions({
      createReset: 'exsbinvoicetype/create/reset',
      deleteItem: 'exsbinvoicetype/del/del',
      delReset: 'exsbinvoicetype/del/reset',
      retrieve: 'exsbinvoicetype/update/retrieve',
      updateReset: 'exsbinvoicetype/update/reset',
      update: 'exsbinvoicetype/update/update',
      updateRetrieved: 'exsbinvoicetype/update/updateRetrieved'
    }),

    del () {
      if (window.confirm('Are you sure you want to delete this exsbinvoicetype ?')) {
        this.deleteItem(this.retrieved)
      }
    },

    reset () {
      this.updateReset()
      this.delReset()
      this.createReset()
    },

    onSendForm () {
      this.update()
    },

    updateField (field, value) {
      this.updateRetrieved({ [field]: value })
    }
  }
}
</script>
